var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 25,
    viewBox: "0 0 46 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.036 17.9303L19.2975 21.9914H19.2995L17.6157 24.6796L3.13272 15.29V24.7274H0V0.815093H3.13272V4.19071C4.73236 1.83535 7.40105 0.291016 10.428 0.291016C15.3229 0.291016 19.2897 4.32821 19.2897 9.30993C19.2897 13.3671 16.6582 16.7965 13.036 17.9303ZM16.157 9.30993C16.157 6.09572 13.5862 3.47932 10.428 3.47932C7.26986 3.47932 4.69908 6.09572 4.69908 9.30993C4.69908 12.5241 7.26986 15.1405 10.428 15.1405C13.5862 15.1405 16.157 12.5241 16.157 9.30993ZM42.8222 17.3684V0.815093H45.9549V24.7274H42.8222L35.7736 8.17211V24.7274H32.6409L25.5923 8.17211V24.7274H22.4595V0.815093H25.5923L32.6409 17.3684V0.815093H35.7736L42.8222 17.3684Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmLogo);
export default __webpack_public_path__ + "static/media/rm-logo.aa10ba29c8f1a3601f33ebb48141ff93.svg";
export { ForwardRef as ReactComponent };